import {
  closestCorners,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToWindowEdges } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import PropTypes from "prop-types";
import { useState } from "react";

const Context = ({ dragOverlay, schema, setSchema, children }) => {
  const [activeNode, setActiveNode] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function onDragStart(event) {
    setActiveNode(event.active.id);
  }
  function onDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const groups = schema.groups;
      const oldIndex = groups.map((e) => e.legend).indexOf(active.id);
      const newIndex = groups.map((e) => e.legend).indexOf(over.id);
      const newArr = arrayMove(groups, oldIndex, newIndex);

      setSchema({ groups: newArr });
    }
  }

  return (
    <DndContext
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
      collisionDetection={closestCorners}
      sensors={sensors}
    >
      {schema?.groups && (
        <SortableContext
          items={schema?.groups}
          strategy={verticalListSortingStrategy}
        >
          {children}
        </SortableContext>
      )}
      <DragOverlay modifiers={[restrictToWindowEdges]}>
        {activeNode && dragOverlay ? dragOverlay(activeNode) : null}
      </DragOverlay>
    </DndContext>
  );
};

Context.propTypes = {
  schema: PropTypes.object.isRequired,
  setSchema: PropTypes.func.isRequired,
  dragOverlay: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default Context;
